import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { RouterProvider } from "react-router-dom";
import { StrictMode } from "react";
import { Provider } from "react-redux";
import store from "./redux/store";
import "./i18next";
import { initializeParse } from "@parse/react";
import { router } from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import "./assets/fonts/Caveat/Caveat-Bold.ttf";

initializeParse(
  "https://parseapi.back4app.com/",
  "VqIbpuRJ7gqgb7NkxZ8mUwzlhpqE0EZRDchIZDoq",
  "bW0WTXF1V8OUiLsKbYZdNvmk2qduUgzDfVBvc5HG"
);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <StrictMode>
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  </StrictMode>
);
serviceWorkerRegistration.register();
reportWebVitals();
